var map = {
	"./defaultText_de.json": 1732,
	"./defaultText_en.json": 4720,
	"./defaultText_es.json": 39,
	"./defaultText_fr.json": 915,
	"./defaultText_it-dom.json": 3819,
	"./defaultText_it.json": 4702,
	"./defaultText_nl.json": 6425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6822;